/**
 * Formats an academic year as "YYYY-YY" (e.g. "2026-27").
 *
 * Accepts a date (the school's academic_start_date from settings), a 4-digit
 * year, or an already-formatted "YYYY-YY" string. Mirrors the backend rule in
 * fee-transaction.service.ts so both surfaces agree on the format.
 *
 * Returns "" when the value is missing or unparseable, so callers can fall
 * back to the current calendar year.
 */
export function toAcademicYear(value) {
  if (value === null || value === undefined || value === "") return "";

  const str = String(value).trim();
  if (/^\d{4}-\d{2}$/.test(str)) return str;

  let startYear;
  if (/^\d{4}$/.test(str)) {
    startYear = parseInt(str, 10);
  } else {
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) return "";
    startYear = parsed.getFullYear();
  }

  return `${startYear}-${String(startYear + 1).slice(-2)}`;
}

/**
 * Resolves the academic year from the school settings payload returned by
 * GET /classes/default-dates, falling back to the current calendar year when
 * the academic start date has not been configured yet.
 */
export function academicYearFromSettings(defaultDates) {
  return (
    toAcademicYear(defaultDates?.academic_start_date) ||
    toAcademicYear(new Date().getFullYear())
  );
}
